module.exports = __webpack_public_path__ + "img/172424 Backup.c244a1d0.png";